<div class="center w-full flex items-center">
  <div class="text-gray-500 w-full border-b"></div>
  <div class="text-center  mx-4">Hoặc</div>
  <div class="text-gray-500 w-full border-b"></div>
</div>